import React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { HexColorPicker } from 'react-colorful';

export default function ColorList(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (color) => {
    setAnchorEl(null);
    if (color) {
      props.onChange(color);
    }
  };

  const renderColor = (color, size = 28) => (
    <Box
      sx={{
        width: size,
        height: size,
        backgroundColor: color,
        borderRadius: '4px',
        border: '1px solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 2px rgba(0,0,0,0.15)'
      }}
    />
  );

  return (
    <>
      <IconButton
        aria-label={typeof props.label === 'string' ? props.label : 'Choose color'}
        onClick={handleOpen}
        sx={{
          padding: '6px'
        }}>
        {renderColor(props.value || '#f7c315', 32)}
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        MenuListProps={{
          sx: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 1,
            padding: 1
          }
        }}>
        {props.customPicker && (
          <Box sx={{ p: 1, mb: 1, gridColumn: '1 / -1' }}>
            <HexColorPicker color={props.value || '#f7c315'} onChange={props.onChange} />
          </Box>
        )}
        {(props.options || []).map((color) => (
          <MenuItem
            key={color}
            aria-label={color}
            onClick={() => handleClose(color)}
            sx={{
              minWidth: 'auto',
              padding: '4px',
              borderRadius: '4px'
            }}>
            {renderColor(color, 30)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
